import axios from 'axios';
import {
  SSO_APIGEE_BASE_PATH,
  STORE_MOBILE_SSO_DELETE,
  STORE_MOBILE_SSO_UPDATE,
  STORE_MOBILE_SSO_VALIDATE,
  USER_DATA,
} from './constants';

import { UserData } from './types';
import { logSSOError } from './services/whispersSsoLoggingService';

export function getAuthHeaders() {
  const logInValuesJSON = sessionStorage.getItem('loginData');
  const logInValues = logInValuesJSON && JSON.parse(logInValuesJSON);

  return {
    Authorization: `Bearer ${logInValues?.access_token}`,
  };
}

export const getUID = (): string | null => {
  const userData = sessionStorage.getItem(USER_DATA);
  if (userData) {
    const parsedUserData: UserData = JSON.parse(userData);
    const { sub } = parsedUserData;
    return sub || null;
  }
  return null;
};


export async function deleteSSOSessions() {
  try {
    const SSO_APIGEE_BASE_URL = sessionStorage.getItem('APIGEE_BASE_URL');
    const url = `${SSO_APIGEE_BASE_URL}${SSO_APIGEE_BASE_PATH}${STORE_MOBILE_SSO_DELETE}`;
    return await axios.delete(url, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error('delete SSO token failed:', error);
    logSSOError('delete', error, getUID());
    return error;
  }
}

export async function updateSSOSessions() {
  try {
    const SSO_APIGEE_BASE_URL = sessionStorage.getItem('APIGEE_BASE_URL');
    const url = `${SSO_APIGEE_BASE_URL}${SSO_APIGEE_BASE_PATH}${STORE_MOBILE_SSO_UPDATE}`;
    return await axios.post(url, {}, { headers: getAuthHeaders() });
  } catch (error) {
    console.error('update SSO token failed:', error);
    logSSOError('update', error, getUID());
    throw error;
  }
}

export async function validateSSOSessions() {
  try {
    const SSO_APIGEE_BASE_URL = sessionStorage.getItem('APIGEE_BASE_URL');
    const url = `${SSO_APIGEE_BASE_URL}${SSO_APIGEE_BASE_PATH}${STORE_MOBILE_SSO_VALIDATE}`;
    return await axios.get(url, { headers: getAuthHeaders() });
  } catch (error) {
    console.error('Validate SSO token failed:', error);
    logSSOError('validate', error, getUID());
    throw error;
  }
}
